import { ConstructionIcon } from 'lucide-react'
import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import PageTitle from '@/components/ui/page-title'
import { type TranslationKeys } from '@/i18n/translation-shape'
import { cn } from '@/lib/utils'

// Page complète pour les routes prévues dans la structure mais pas encore développées : titre + placeholder.
export function UnderConstructionPage({ titleKey, icon, descriptionKey }: { titleKey: TranslationKeys; icon?: ReactNode; descriptionKey?: TranslationKeys }) {
  const { t } = useTranslation()

  return (
    <div className="flex grow flex-col gap-8">
      <PageTitle title={t(titleKey)} icon={icon} />
      <UnderConstruction descriptionKey={descriptionKey} />
    </div>
  )
}

// Placeholder partagé : affiché à la place du contenu d'une page prévue dans la structure mais pas
// encore développée. Le titre de la page reste rendu par la page elle-même. `descriptionKey`
// remplace le message générique par un horizon de livraison propre à la page.
export default function UnderConstruction({ className, descriptionKey }: { className?: string; descriptionKey?: TranslationKeys }) {
  const { t } = useTranslation()

  return (
    <div className={cn('flex flex-1 items-center justify-center py-10 sm:py-16', className)}>
      <div className="flex w-full max-w-md flex-col items-center gap-5 rounded-xl border border-dashed border-muted-foreground/30 bg-muted/30 px-6 py-10 text-center sm:py-14">
        <div className="rounded-full bg-amber-100 p-4 text-amber-600">
          <ConstructionIcon className="size-10" strokeWidth={1.5} />
        </div>
        <div className="flex flex-col gap-1.5">
          <h2 className="text-lg font-semibold">{t('underConstruction.title')}</h2>
          <p className="text-sm text-muted-foreground">{t(descriptionKey ?? 'underConstruction.description')}</p>
        </div>
      </div>
    </div>
  )
}
